<template>
  <div>
    <div v-if="canSign">
        <p clsas="font-weight-bold" style="padding-bottom: 25px;">{{ infoText }}</p>
        <canvas id="signature" style="border: 1px solid #000000;" width="400" height="150"></canvas>
    </div>
    <v-btn class="primary" @click="clearCanvas()" v-if="canClear">{{ buttonClearText }}
    </v-btn>
    <v-btn class="primary" @click="acceptSignature()" v-if="canAcceptSignature">{{ buttonAcceptText }}
    </v-btn>
    <p class="esign-error-text" v-if="operationUuidMsg">El identificador de la operación es un campo obligatorio para poder firmar el documento.</p>
    <p class="esign-error-text" v-if="documentUuidMsg">El identificador del documento es un campo obligatorio para poder firmar el documento.</p>
    <p id="snackbar-success"></p>
    <p id="snackbar-error"></p>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    token: String,
    endPoint: String,
    operationUuid: String,
    documentUuid: String,
    signBoxName: String,
    signaturePoints: Number,
    infoText: String,
    buttonClearText: String,
    buttonAcceptText: String,
    buttonText: String,
    status: {
      type: Number,
      default: 0
    },
    response: {
      type: String,
      default: ""
    },
    loading: Boolean,
    snackBar: Boolean,
    successMsg: String,
    errorMsg: String
  },
  data() {
    return {
      canSign: true,
      operationUuidMsg: false,
      documentUuidMsg: false,
      canAcceptSignature: false,
      canClear: false,
      canDraw: true,
      imgb64: String,
      paint: false,
      clickX: [],
      clickY: [],
      clickDrag: []
    };
  },
  created() {
    this.operationUuidMsg =
      (typeof this.operationUuid === "undefined" ||
        this.operationUuid === "") === true;
    this.documentUuidMsg =
      (typeof this.documentUuid === "undefined" || this.documentUuid === "") ===
      true;
    if (this.operationUuidMsg === true || this.documentUuidMsg === true) {
      this.canSign = false;
    }
  },
  mounted() {
    this.initCanvasToDraw();
  },
  methods: {
    initCanvasToDraw() {
      const $this = this;
      $this.canvasDraw = document.getElementById("signature");
      $this.contextDraw = $this.canvasDraw.getContext("2d");
      $this.BB = $this.canvasDraw.getBoundingClientRect();
      function doMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.paint = true;
        if ($this.canDraw) {
          $this.addClick(e.offsetX, e.offsetY, false);
          $this.redraw();
        }
      }
      function doMouseMove(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($this.paint && $this.canDraw) {
          $this.addClick(e.offsetX, e.offsetY, true);
          $this.redraw();
        }
      }
      function doMouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.paint = false;
      }
      function doMouseLeave(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.paint = false;
      }
      function doTouchStart(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.paint = true;
        if ($this.canDraw) {
          $this.addClick(
            e.touches[0].clientX - $this.BB.left,
            e.touches[0].clientY - $this.BB.top,
            false
          );
          $this.redraw();
        }
      }
      function doTouchMove(e) {
        e.preventDefault();
        e.stopPropagation();
        if ($this.paint && $this.canDraw) {
          $this.addClick(
            e.touches[0].clientX - $this.BB.left,
            e.touches[0].clientY - $this.BB.top,
            true
          );
          $this.redraw();
        }
      }
      function doTouchEnd(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.paint = false;
      }
      $this.canvasDraw.addEventListener("mousedown", doMouseDown, false);
      $this.canvasDraw.addEventListener("mousemove", doMouseMove, false);
      $this.canvasDraw.addEventListener("mouseup", doMouseUp, false);
      $this.canvasDraw.addEventListener("mouseleave", doMouseLeave, false);
      $this.canvasDraw.addEventListener("touchstart", doTouchStart, false);
      $this.canvasDraw.addEventListener("touchmove", doTouchMove, false);
      $this.canvasDraw.addEventListener("touchend", doTouchEnd, false);
    },
    addClick(x, y, dragging) {
      this.canClear = true;
      this.clickX.push(x);
      this.clickY.push(y);
      this.clickDrag.push(dragging);
    },
    redraw() {
      this.contextDraw.strokeStyle = "#000000";
      this.contextDraw.lineJoin = "miter";
      this.contextDraw.lineWidth = 2;
      for (var i = 0; i < this.clickX.length; i += 1) {
        this.contextDraw.beginPath();
        if (this.clickDrag[i] && i) {
          this.contextDraw.moveTo(this.clickX[i - 1], this.clickY[i - 1]);
        } else {
          this.contextDraw.moveTo(this.clickX[i] - 1, this.clickY[i]);
        }
        this.contextDraw.lineTo(this.clickX[i], this.clickY[i]);
        this.contextDraw.closePath();
        this.contextDraw.stroke();
      }

      if (
        this.clickX.length > this.signaturePoints &&
        this.clickY.length > this.signaturePoints
      ) {
        this.canAcceptSignature = true;
      }
    },
    clearCanvas() {
      this.canClear = false;
      this.canAcceptSignature = false;
      this.contextDraw.clearRect(
        0,
        0,
        this.contextDraw.canvas.width,
        this.contextDraw.canvas.height
      );
      this.clickX = [];
      this.clickY = [];
      this.clickDrag = [];
    },
    acceptSignature() {
      this.EventBus.$emit("notifyFingerSignature", "showLoading");
      this.canClear = false;
      this.canAcceptSignature = false;
      this.canDraw = false;
      if (
        document
          .getElementById("signature")
          .toDataURL()
          .indexOf("data:image") !== -1
      ) {
        this.imgb64 = document
          .getElementById("signature")
          .toDataURL()
          .split(",")[1];
      } else {
        this.imgb64 = document.getElementById("signature").toDataURL();
      }
      axios.defaults.headers.common.Authorization = this.token;
      if (this.loading) {
        this.showLoading();
      }
      this.data = {};
      this.data.operationUuid = this.operationUuid;
      this.data.documentUuid = this.documentUuid;
      this.data.signaturetype = "6";
      this.data.message = "";
      this.data.signboxName = this.signBoxName;
      this.data.b64img = this.imgb64;
      axios
        .post(
          `${this.endPoint}${this.operationUuid}${"/"}${this.documentUuid}`,
          this.data,
          { headers: { "Content-type": "Application/json" } }
        )
        .then(
          () => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-success", this.successMsg);
            }
            this.EventBus.$emit("notifyFingerSignature", "hideLoading");
            this.EventBus.$emit("successFingerSignature", this.imgb64);
            this.$router.push({ name: "resumeSignature" });
          },
          () => {
            if (this.loading) {
              this.hideLoading();
            }
            if (this.snackBar) {
              this.$showSnackBar("snackbar-error", this.errorMsg);
            }
            this.EventBus.$emit("notifyFingerSignature", "hideLoading");
            this.EventBus.$emit("errorFingerSignature");
            this.canClear = true;
          }
        );
    }
  }
};
</script>
